// autarkyBadge.js

/**
 * @param {number} pvToConsumer   [W]
 * @param {number} pvToGrid       [W]
 * @param {number} gridToConsumer [W]
 * @returns {number} Autarky percentage (may exceed 100)
 */
function computeAutarky (pvToConsumer, pvToGrid, gridToConsumer) {
  const consumption = gridToConsumer + pvToConsumer;
  if (consumption <= 0) {
    return 0;
  }
  if (gridToConsumer <= 0) {
    return ((pvToConsumer + pvToGrid) / pvToConsumer) * 100;
  }
  return (pvToConsumer / consumption) * 100;
}

/**
 * Interpolates hue from 0° (red) to 120° (green) for autarky 0–100%.
 * Clamped at 100% — values above stay green.
 *
 * @param {number} autarky
 * @returns {string} CSS background-color value
 */
function computeColor (autarky) {
  const hue = Math.round(Math.min(autarky, 100) * 1.2); // 0 → 0°, 100 → 120°
  return `hsl(${hue}, 80%, 42%)`;
}

const badge = document.getElementById('autarky-badge');

if (badge !== null) {
  // Static styles applied once.
  badge.style.color = '#ffffff';
  badge.style.textShadow = '0 1px 2px rgba(0,0,0,0.6)';
  badge.style.fontWeight = '600';

  document.addEventListener('latestDataUpdate', (/** @type {CustomEvent} */ event) => {
    const {pvToConsumer, pvToGrid, gridToConsumer} = event.detail;
    const autarky = computeAutarky(pvToConsumer, pvToGrid, gridToConsumer);

    badge.style.backgroundColor = computeColor(autarky);
    badge.textContent = Math.round(autarky) + '\u202f%';
    badge.style.display = '';
  });
}
